import Vue from 'vue'
import Router from 'vue-router'
import list from './c_router'
Vue.use(Router)
const routes = [
  {
    path: '/',
    component: () => import('@/views/homIndex/index'),
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/homIndex/home'),
		meta: {
		  keepAlive: true,
		  title: '营销案例'
		}
      },
      {
        path: '/bcourse',
        name: 'bcourse',
        component: () => import('@/views/b_course/bcourse'),
        meta: {
		  keepAlive: true,
          title: '精品课程'
        }
      },
      {
        path: '/me',
        name: 'me',
        component: () => import('@/views/homIndex/me'),
		meta: {
		  keepAlive: true,
		  title: '个人中心'
		}
      }
    ]
  },
  {
    path: '/open',
    name: 'open',
    meta: {
      title: '开通拓客',
      isShow: true
    },
    component: () => import('@/views/homIndex/open')
  },
  {
    path: '/advert',
    name: 'advert',
    meta: {
      title: '我的广告',
      isShow: true
    },
    component: () => import('@/views/advert/index')
  },
  {
    path: '/createdAdvert',
    name: 'createdAdvert',
    meta: {
      title: '创建文字广告',
      isShow: true
    },
    component: () => import('@/views/advert/createdAdvert')
  },
  {
    path: '/article',
    name: 'articles',
    component: () => import('@/views/article/index'),
	meta: {
	  keepAlive: true,
	  title: '我的文章'
	}
  },
  {
    path: '/mySetting',
    name: 'mySetting',
    component: () => import('@/views/myCenter/setting')
  },
  {
    path: '/myClient',
    name: 'myClient',
    component: () => import('@/views/myCenter/myclient')
  },
  {
    path: '/clientDetails',
    name: 'clientDetails',
    component: () => import('@/views/myCenter/clientDetails')
  },
  {
    path: '/articleEdit',
    name: 'articleEdit',
    component: () => import('@/views/article/articleEdit')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('@/views/article/details')
  },
  {
    path: '/myCard',
    path: '/myCard',
    name: 'myCard',
    component: () => import('@/views/myCenter/myCard')
  },
  {
    path: '/aboutmeEdit',
    name: 'aboutmeEdit',
    component: () => import('@/views/myCenter/aboutmeEdit')
  },
  {
    path: '/addRemarks',
    name: 'addRemarks',
    component: () => import('@/views/myCenter/addRemarks')
  },
  {
    path: '/choiceArtcle',
    path: '/choiceArtcle',
    name: 'choiceArtcle',
    component: () => import('@/views/myCenter/choiceArtcle')
  },
  {
    path: '/articleStatistics',
    name: 'articleStatistics',
    component: () => import('@/views/article/articleStatistics')
  },

  {
    path: '/video',
    name: 'video',
    meta: {
      title: '视频详情',
      isShow: true
    },
    component: () => import('@/views/article/video')
  },

  {
    path: '/videoList',
    name: 'videoList',
    meta: {
      title: '我的视频',
      isShow: true,
	  keepAlive: true,
    },
    component: () => import('@/views/article/videoList')
  },
  
  {
    path: '/changeMe',
    name: 'changeMe',
    meta: {
      title: '免费换成我的视频',
      isShow: true
    },
    component: () => import('@/views/article/changeMe')
  },
  {
	path: '/buyUser',
	name: 'buyUser',
	meta: {
	  title: '买课用户',
	 
	},
	component: () => import('@/views/myCenter/buyUser')  
  },
  {
    path: '/complaint',
    name: 'complaint',
    component: () => import('@/views/complaint'),
    meta: {
      title: '投诉'
    }
  },
  {
    path: '/b_courseDetails',
    name: 'b_courseDetails',
    component: () => import('@/views/b_course/b_courseDetails')
  },
  {
    path: '/bmyCourse',
    name: 'bmyCourse',
    component: () => import('@/views/b_course/bmyCourse'),
	meta: {
	  title: '我的课程',
	   keepAlive: true,
	}
  },
  {
    path: '/help',
    name: 'help',
    meta: {
      title: '私域拓客',
      isShow: true
    },
    component: () => import('@/views/homIndex/help')
  },
  {
    path: '/commission',
    name: 'commission',
    meta: {
      title: '资金管理',
    },
    component: () => import('@/views/fenyong/list')
  },
  {
    path: '/Withdrawal',
    name: 'Withdrawal',
    meta: {
      title: '提现',
    },
    component: () => import('@/views/fenyong/Withdrawal')
  },
  {
    path: '/ticketDetails_b',
    name: 'ticketDetails_b',
    meta: {
      title: '门票详情', //门票详情b
    },
    component: () => import('@/views/c_main/ticket/ticketDetails_b')
  },
  
]
let arr = []
arr = [...routes, ...list.list]

export default new Router({
  mode: 'hash',
  routes: arr,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

